import {
  ICalendarHoliday,
  ICalendarHolidayData,
  ITimeOffCalendar,
  ITimeOffCalendarData
} from '../timeoff-calendar.types';
import { CalendarHoliday, TimeOffCalendar } from '../timeoff-calendar';
import { ICalendarTimeOffHolidaysData } from '@/store/timeoff-calendar';

export const mockTimeOffCalendarsData = (): ITimeOffCalendarData[] => [
  {
    id: 2,
    name: 'Canadian Holiday',
    country: { code: 'CA', name: 'Canada' }
  },
  {
    id: 1,
    name: 'Badadian Holiday',
    country: { code: 'BB', name: 'Barbados' }
  }
];

export const mockCalendarHolidaysData = (): ICalendarTimeOffHolidaysData[] => [
  {
    calendar: 1,
    holidays: [
      {
        id: 1,
        name: "M'Nadi Grant",
        date: '2022-09-29',
        is_paid: true,
        calendar: 1
      },
      {
        id: 2,
        name: "M'Nadi Grant",
        date: '2022-09-30',
        is_paid: false,
        calendar: 1
      }
    ]
  }
];

export const mockTimeOffCalendars = (
  data: ITimeOffCalendarData[] = mockTimeOffCalendarsData()
): ITimeOffCalendar[] => data.map(item => new TimeOffCalendar(item));
